import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApi } from '../../services/backend-api';
import { Package, PackagePatch } from '../../models/package';
import { TextFieldModule } from '@angular/cdk/text-field';


@Component({
  selector: 'app-update-package-dialog',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule, TextFieldModule],
  templateUrl: './update-package-dialog.html',
  styleUrl: './update-package-dialog.css',
})
export class UpdatePackageDialog {
  constructor(
    private readonly backendApi: BackendApi,
    private dialogRef: MatDialogRef<UpdatePackageDialog>,
    @Inject(MAT_DIALOG_DATA) public thePackage: Package
  ) { }
  
  private _snackBar = inject(MatSnackBar);
  private _formBuilder = inject(FormBuilder);

  packageTypes = [
    { value: "monthly", label: "Mensuel" },
    { value: "unlimited", label: "Illimité" }
  ];

  packageForm = this._formBuilder.group({
    name: ['', Validators.required],
    description: ['', Validators.required],
    type: ['monthly', Validators.required],
    priority_level: [0, Validators.required],
    limit: [0, Validators.required]
  });

  ngOnInit() {
    this.packageForm.get('name')?.setValue(this.thePackage.name);
    this.packageForm.get('description')?.setValue(this.thePackage?.description ?? '');
    this.packageForm.get('type')?.setValue(this.thePackage.type);
    this.packageForm.get('priority_level')?.setValue(this.thePackage.priority_level);

    if (this.thePackage.type == 'monthly') {
      // Convert seconds to minutes (/60) to hours (/60 again)
      const limit = this.thePackage.limit / 60 / 60
      this.packageForm.get('limit')?.setValue(limit);
    }
  }

  submit() {
    const packagePatch: PackagePatch = this.packageForm.value as PackagePatch;

    // Convert hours to minutes (x60) to seconds (x60 again)
    packagePatch.limit = packagePatch.limit * 60 * 60;

    this.backendApi.patchPackage(this.thePackage.uuid, packagePatch).subscribe({
      next: (patchedPackage) => {
        this._snackBar.open("Forfait modifié.");
        this.dialogRef.close(patchedPackage);
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la modification du forfait.");
      }
    })
  }
}
